/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Payment_ConfirmedInputs */

const vi_pos_payment_confirmed = /** @type {(inputs: Pos_Payment_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thanh toán!`)
};

/**

* @param {Pos_Payment_ConfirmedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_payment_confirmed = /** @type {((inputs?: Pos_Payment_ConfirmedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Payment_ConfirmedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_payment_confirmed(inputs)
});